import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ReasonItemContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 32px;
  width: 100%;
  flex-direction: row;
  padding: 16px 0;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-direction: column;
    padding: 24px;
  }
`;

export const ImageWrapper = styled(Box)`
  width: 70px;
  height: 70px;
  margin: 0 auto;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 100px;
    height: 100px;
  }
`;

export const ReasonDescription = styled(Box)`
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ul,
  ol,
  dl,
  dt,
  dd {
    margin: 0px;
  }
`;
